var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoWhiteLogo = function SvgLogoWhiteLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2032,
    height: 600,
    viewBox: "0 0 2048 604"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2AB3E7",
    d: "m1072 48 3 4 17 34 11 23 12 24 11 23 17 34-2 4-14 19-14 18-14 19-10 13-16 21-14 19-14 18-14 19-32 42-14 19-14 18-6 9 5-1 174-8h20l-7-8-60-60-7-8-21-21 2-5 14-19 16-21 13-18 16-21 10-14 10-13h2l15 34 117 270 16 37 1 4-7-6-36-36-7-8-70-70-7-8-7-7-9 3-35 16-36 16-19 9-68 31-36 16-32 15-36 16-26 12h-2l1-6 14-34 14-35 17-42 23-57 115-285 19-47z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#388DCA",
    d: "m1161 344 4 5 26 39 25 38 21 32 36 55 17 26 8 12-1 2-39-39-7-8-70-70-7-8-8-8-1-4-4-55z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D0F0",
    d: "M1150 211h2l1 3v16l7 98v12h-2l-10-16-14-21-23-35-2-2 28-38zM1072 48l3 4 17 34 11 23 6 13-13 24-13 23-16 29-14 25-30 54-14 25-15 27-13 24-13 23-16 29-14 25-25 45-12 21-13 24-12 21-6 12v2h-2l1-6 14-34 14-35 17-42 23-57 115-285 19-47z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#388CCA",
    d: "m1108 122 3 3 17 35 15 30-2 4-14 19-14 18-14 19-10 13-16 21-14 19-14 18-14 19-32 42-14 19-14 18-5 7h-1l1-8 19-67 5-17 15-27 14-25 30-54 14-25 30-54z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#79B9E8",
    d: "M1150 211h2l15 34 117 270 16 37 1 4-3-2-5-9-21-32-19-29-17-26-75-114-18-27-16-25-16-24-2-2 28-38z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#398CCA",
    d: "M1154 421h4v3l-35 16-36 16-19 9-68 31-36 16-32 15-36 16-24 11-3-1 8-16 13-23 16-29 9-15 214-44z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#79B9E8",
    d: "m1072 48 3 4 17 34 11 23 6 13-13 24-13 23-16 29-14 25-30 54-14 25-15 27h-1l1-9 16-55 31-109 19-67 10-35 1-5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2AB3E7",
    d: "m988 338 1 3-15 52-8 28-1 7 5-1 174-8h20l-2 1v2l-4 1v-2l-238 49h-4l2-6 16-29 14-25 30-54z"
  })));
};
export default SvgLogoWhiteLogo;